





































import Vue from 'vue'
import Component from 'vue-class-component'
import axios from 'axios'
import { Watch, Prop } from 'vue-property-decorator'

// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

@Component
export default class PracticumEditDialog extends Vue {
  data = {}

  editor = ClassicEditor

  @Prop({ default: null })
  initialData!: Object

  @Prop({ default: false })
  open!: boolean

  mounted() {
    if (this.initialData) {
      this.data = { ...this.initialData }
    }
  }

  @Watch('initialData')
  initialDataChanged(value: any, oldValue: any) {
    this.data = { ...value }
  }

  editorConfig = {
    toolbar: [
      'heading', '|', 'bold', 'italic', 'blockQuote',' |',
      'indent', 'outdent', '|',
      'numberedList', 'bulletedList', 'link', '|',
      'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells','|',
      'undo', 'redo'
    ]
  }

  requiredField = (val: any) => !!val || 'Value is required'

  cancel() {
    this.$emit('cancel')
  }

  submit() {
    this.$emit('save', this.data)
  }
}
